<script lang="ts">
    import { useLocation, Link } from "svelte-navigator";
    export let gallery = {
        gallery: "",
        icon: "",
        id: "",
        priority: "",
        title: "",
    };
</script>

<div class="item">
    <Link to={gallery.id}>
        <img src={gallery.icon} alt="noImage" />
    </Link>
    <div class="item-title">
        <h3>{gallery.title}</h3>
    </div>
</div>

<style>
    .item {
        display: flex;
        flex-flow: column;
        max-width: 100%;
        outline: rgb(59, 59, 59) solid 5px;
        /* border-radius: 0.1px; */
        margin-bottom: 20px;
    }

    .item img {
        flex: 0 1 auto;
        /* min-height: 85%;
        max-height: 85%; */
        background-color: rgb(59, 59, 59);
        margin-bottom: 0px;
        object-fit: cover;
    }

    .item-title {
        flex: 1;
        background-color: rgb(59, 59, 59);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .item-title h3 {
        flex: 1 1 auto;
        margin: 10px;
    }

    @media (min-width: 640px) {
        .item {
            float: left;
            max-width: 20.333%;
            margin: 10px;
        }
    }
</style>
